import * as action from "./actions";

export const getVendors = id => {
  return {
    type: action.GET_VENDORS,
    payload: id
  };
};

export const setVendors = vendors => {
  return {
    type: action.SET_VENDORS,
    payload: vendors
  };
};

const ACTION_HANDLERS = {
  [action.GET_VENDORS]: (state, action) => {
    return { ...state };
  },
  [action.SET_VENDORS]: (state, action) => {
    return { ...state, ...action.payload };
  }
};

let defaultState = {};

export const reducer = (state = defaultState, action) => {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};
